/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { useTranslation } from "react-i18next";
import "./index.less";
import { cdnUrl } from "@/utils/cdn";
import { message } from "antd";
import { formatUnits } from "viem";
const WalletOperate = ({
  account,
  balance,
}: {
  account: any;
  balance: any;
}) => {
  const { t, i18n } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();
  // console.log("accountaccountaccount", account)
  //复制地址
  const copy = async (content: any) => {
    await navigator.clipboard.writeText(content);
    messageApi.open({
      type: "success",
      // content: "复制成功",
      content: t("customizedAuthorization.pasteSuccess"),
    });
  };
  return (
    <div className="wallet-container">
      {contextHolder}
      <div className="half-section">
        <div className="label">
          {t("customizedAuthorization.walletAddressLabelSimple")}
        </div>
        <div className="value-box left-box">
          {account ? (
            <div className="wallet-address">
              <div className="address">{account.address}</div>
              <img
                src={cdnUrl("/img/bsc/copy.svg")}
                className="copy_img"
                alt=""
                onClick={(e) => {
                  e.preventDefault(); // 阻止默认行为
                  e.stopPropagation(); // 阻止冒泡，防止触发 Select 展开
                  copy(account.address);
                }}
              />
            </div>
          ) : (
            <div className="placeholder">
              {t("customizedAuthorization.pleaseConnectWallet")}
            </div>
          )}
        </div>
      </div>

      <div className="half-section right">
        <div className="label">{t("customizedAuthorization.BnbBalance")}</div>
        <div className="value-box right-box">{formatUnits(balance, 9) || "-"}</div>
      </div>
    </div>
  );
};

export default WalletOperate;
